import firebase from 'firebase/app'
import { Inquiry, Inquiries } from '@/models/Inquiry'

class InquiryRepository {
  constructor(client) {
    this.collection = client.collection('inquiries')
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put(
    inquirer,
    email,
    category,
    content
  ) {
    const docRef = await this.collection.doc()
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const inquiry = new Inquiry(
      docRef.id,
      inquirer,
      email,
      category,
      content,
      false, // isAnsewerd
      timestamp,
      timestamp
    )
    const object = inquiry.toObject()
    await docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createInquiryFromFireStoreData(result.id, data)
  }

  async find (id) {
    const result = await this.collection.doc(id).get()
    const data = result.data(this.snapShotOptions)
    return createInquiryFromFireStoreData(result.id, data)
  }

  async list () {
    const snapShot = await this.collection.get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createInquiryFromFireStoreData(doc.id, doc.data()))
    })
    return createInquiriesFromFireStoreData(arr)
  }
}

const createInquiryFromFireStoreData = (id, data) => {
  return new Inquiry(
    id,
    data.inquirer,
    data.email,
    data.category,
    data.content,
    data.isAnswered,
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

const createInquiriesFromFireStoreData = (arr) => {
  return new Inquiries(arr)
}

export { InquiryRepository }